import { createReducer, on } from "@ngrx/store";
import { EditGroupState, initialEditGroupState } from "./edit-group.state";
import { EditGroup, EditGroupError, EditGroupSuccess, ResetEditGroup, SetEditGroup, SetEditGroupError, SetEditGroupSuccess } from "./edit-group.actions";

export const EditGroupReducers = createReducer(
  initialEditGroupState,
  on(SetEditGroup, (state): EditGroupState => {
    return {
      ...state,
      group: null,
      loading: true,
      error: null
    };
  }),
  on(SetEditGroupSuccess, (state, action): EditGroupState => {
    return {
      ...state,
      group: action.group,
      loading: false,
    };
  }),
  on(SetEditGroupError, (state, action): EditGroupState => {
    return {
      ...state,
      loading: false,
      error: action.error
    };
  }),
  on(EditGroup, (state): EditGroupState => {
    return {
      ...state,
      loading: true,
      result: null,
      error: null
    }
  }),
  on(EditGroupSuccess, (state, action): EditGroupState => {
    return {
      ...state,
      loading: false,
      result: action.group
    }
  }),
  on(EditGroupError, (state, action): EditGroupState => {
    return {
      ...state,
      loading: false,
      error: action.error
    }
  }),
  on(ResetEditGroup, (state): EditGroupState => {
    return {
      ...state,
      loading: false,
      error: null,
      result: null,
      group: null
    }
  })
)